import { render, staticRenderFns } from "./EternityUpgradesTab.vue?vue&type=template&id=6c706890&scoped=true&"
import script from "./EternityUpgradesTab.vue?vue&type=script&lang=js&"
export * from "./EternityUpgradesTab.vue?vue&type=script&lang=js&"
import style0 from "./EternityUpgradesTab.vue?vue&type=style&index=0&id=6c706890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c706890",
  null
  
)

export default component.exports